import gql from 'graphql-tag';

const CREATE_WORKLOG_TIMER_ENTRY = gql`
  mutation($timerEntryInput: CreateWorklogTimerEntryInput!) {
    createWorklogTimerEntry(input: $timerEntryInput) {
      timerId
      billable
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      type
      notes
      state
      running
      timespent
      workItem {
        workId
        module
        client {
          name
          accountId
        }
        site {
          name
        }
      }
      segments {
        segmentId
        startTime
        endTime
        timespent
        afterHours
      }
      # ticket {
      #   ticketId
      # }
      # project {
      #   projectId
      # }
      createdTime
      module
    }
  }
`;

const UPDATE_WORKLOG_TIMER_ENTRY = gql`
  mutation($timerEntryInput: UpdateWorklogTimerEntryInput!) {
    updateWorklogTimerEntry(input: $timerEntryInput) {
      timerId
      type
      billable
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      notes
      state
      running
      timespent
      workItem {
        workId
        module
        subject
        displayId
        client {
          name
          accountId
        }
        site {
          name
        }
      }
      segments {
        segmentId
        startTime
        endTime
        timespent
        afterHours
      }
      # ticket {
      #   ticketId
      # }
      # project {
      #   projectId
      # }
      createdTime
    }
  }
`;

const UPDATE_WORKLOG_TIMER_ENTRIES = gql`
  mutation($timerEntryInput: [UpdateWorklogTimerEntryInput!]!) {
    updateWorklogTimerEntries(input: $timerEntryInput)
  }
`;

const CREATE_WORKLOG_FROM_TIMERS = gql`
  mutation($input: [WorklogTimerEntryIdentifier!]!) {
    createWorklogEntriesFromTimers(input: $input) {
      itemId
      status
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      billable
      afterHours
      qty
      unitPrice
      billDateTime
      technician {
        name
        userId
      }
      notes
      module
      workItem {
        workId
        module
      }
      segments {
        segmentId
        event {
          startTime
          endTime
        }
        timespent
      }
    }
  }
`;

const CREATE_WORKLOG_FROM_TIMER = gql`
  mutation(
    $createWorklogFromTimerInput: CreateWorklogTimerEntryIdentifierInput!
  ) {
    createWorklogEntryFromTimer(input: $createWorklogFromTimerInput) {
      itemId
      status
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      billable
      afterHours
      qty
      unitPrice
      billDateTime
      technician {
        name
        userId
      }
      notes
      module
    }
  }
`;

const DELETE_WORKLOG_TIMER = gql`
  mutation($deleteWorklogTimerInput: WorklogTimerEntryIdentifier!) {
    deleteWorklogTimerEntry(input: $deleteWorklogTimerInput)
  }
`;

const DELETE_WORKLOG_TIMERS = gql`
  mutation($deleteWorklogTimersInput: [WorklogTimerEntryIdentifier!]!) {
    deleteWorklogTimerEntries(input: $deleteWorklogTimersInput)
  }
`;

const ADD_WORKLOG_ENTRIES = gql`
  mutation($input: AddWorklogEntriesInput!) {
    addWorklogEntries(input: $input) {
      itemId
      status
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      billable
      afterHours
      qty
      unitPrice
      billDateTime
      technician {
        userId
        name
      }
      notes
      module
      segments {
        segmentId
        event {
          startTime
          endTime
        }
        timespent
      }
    }
  }
`;

const CREATE_WORKLOG_ENTRIES = gql`
  mutation($createWorklogEntryInput: [CreateWorklogEntryInput!]!) {
    createWorklogEntries(input: $createWorklogEntryInput) {
      itemId
      status
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      billable
      afterHours
      qty
      unitPrice
      billDateTime
      technician {
        userId
        name
      }
      notes
      module
      segments {
        segmentId
        event {
          startTime
          endTime
        }
        timespent
        afterHours
      }
    }
  }
`;

const UPDATE_WORKLOG_ENTRY = gql`
  mutation($updateWorklogEntryInput: UpdateWorklogEntryInput!) {
    editWorklogEntry(input: $updateWorklogEntryInput) {
      itemId
      status
      serviceItem {
        itemId
        name
      }
      serviceCatalogItem {
        itemId
        name
      }
      billable
      afterHours
      qty
      revisedQuantity
      unitPrice
      billDateTime
      technician {
        userId
        name
      }
      notes
      module
      segments {
        segmentId
        event {
          startTime
          endTime
        }
        timespent
      }
    }
  }
`;

const DELETE_WORKLOG_ENTRY = gql`
  mutation($deleteWorklogInput: WorklogEntryIdentifier!) {
    deleteWorklogEntry(input: $deleteWorklogInput)
  }
`;

const AI_WORKLOGNOTE_GENERATE = gql`
  query convertChatToAIWorklog($ticketId: ID!, $conversationThreadId: ID!) {
    convertChatToAIWorklog(
      ticketId: $ticketId
      conversationThreadId: $conversationThreadId
    )
  }
`;

export {
  CREATE_WORKLOG_TIMER_ENTRY,
  UPDATE_WORKLOG_TIMER_ENTRY,
  UPDATE_WORKLOG_TIMER_ENTRIES,
  CREATE_WORKLOG_FROM_TIMER,
  CREATE_WORKLOG_FROM_TIMERS,
  DELETE_WORKLOG_TIMER,
  CREATE_WORKLOG_ENTRIES,
  UPDATE_WORKLOG_ENTRY,
  DELETE_WORKLOG_ENTRY,
  ADD_WORKLOG_ENTRIES,
  DELETE_WORKLOG_TIMERS,
  AI_WORKLOGNOTE_GENERATE
};
